// frontend/src/theme/components/tabs.js
// getColorSchemeContrast kaldırıldı
import { mode } from '@chakra-ui/theme-tools';

const Tabs = {
  baseStyle: (props) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
    },
    tablist: {
      display: 'flex',
      alignItems: 'center',
    },
    tab: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'semibold',
      fontSize: 'md',
      color: mode('gray.600', 'gray.400')(props),
      transitionProperty: 'common',
      transitionDuration: 'var(--motion-duration-fast)',
      transitionTimingFunction: 'var(--motion-ease-apple)',
      whiteSpace: 'nowrap',
      _focusVisible: {
        zIndex: 1,
        boxShadow: 'outline',
      },
      _disabled: {
        opacity: 0.5,
        cursor: 'not-allowed',
      },
    },
    tabpanel: {
      padding: 0,
    },
    indicator: {},
  }),
  variants: {
    'soft-rounded': (props) => {
      const { colorScheme: c } = props;
      // Manuel Kontrast Renkleri (.100 ve .700 arkaplanlar için)
      const lightSelectedColor = mode(`${c}.700`, `${c}.100`)(props); // Açık modda .100 bg -> .700 text, Koyu modda .700 bg -> .100 text
      const darkSelectedColor = mode(`${c}.700`, `${c}.100`)(props); // Yukarıdaki ile aynı mantık

      return {
        tab: {
          borderRadius: 'full',
          fontWeight: 'medium',
          color: mode('gray.700', 'gray.300')(props),
          paddingX: 4,
          paddingY: 2,
          _selected: {
            // GÜNCELLENDİ: mode ile manuel kontrast
            color: mode(lightSelectedColor, darkSelectedColor)(props),
            bg: mode(`${c}.100`, `${c}.700`)(props),
            boxShadow: mode('sm', 'none')(props),
          },
          _hover: {
            bg: mode(`${c}.50`, `${c}.800`)(props),
          },
          _active: {
            bg: mode(`${c}.200`, `${c}.600`)(props),
          }
        },
      };
    },
    line: (props) => {
      const { colorScheme: c, orientation } = props;
      const borderProp = orientation === 'vertical' ? 'borderStart' : 'borderBottom';
      const marginProp = orientation === 'vertical' ? 'marginStart' : 'marginBottom';

      return {
        tablist: {
          [borderProp]: '2px solid',
          borderColor: mode('gray.200', 'gray.700')(props),
        },
        tab: {
          [borderProp]: '2px solid',
          borderColor: 'transparent',
          [marginProp]: '-2px',
          color: mode('gray.600', 'gray.400')(props),
          _selected: {
            color: mode(`${c}.600`, `${c}.300`)(props),
            borderColor: 'currentColor',
          },
          _hover: {
            borderColor: mode('gray.300', 'gray.600')(props),
          },
          _active: {
            bg: mode('gray.100', 'gray.700')(props),
          },
        },
      };
    },
    enclosed: (props) => {
      const { colorScheme: c } = props;
      return {
        tablist: {
            borderBottomColor: mode('gray.200', 'gray.700')(props),
            borderBottomWidth: '1px',
            mb: '-1px',
        },
        tab: {
          borderTopRadius: 'md',
          borderWidth: '1px',
          borderColor: 'transparent',
          mb: '-1px',
          bg: mode('gray.50', 'gray.800')(props),
          color: mode('gray.600', 'gray.400')(props),
          _selected: {
            color: mode(`${c}.700`, `${c}.100`)(props),
            bg: mode('white', 'gray.700')(props),
            borderColor: mode('gray.200', 'gray.700')(props),
            borderBottomColor: mode('white', 'gray.700')(props),
          },
        },
      };
    },
    pills: (props) => {
        const { colorScheme: c } = props;
        // Manuel Kontrast Renkleri (.500 ve .300 arkaplanlar için - Button solid gibi)
        const lightPillColor = ['yellow', 'cyan', 'gray'].includes(c) ? 'gray.800' : 'white';
        const darkPillColor = c === 'gray' ? 'whiteAlpha.900' : 'gray.800';

        return {
            tab: {
                borderRadius: 'lg',
                fontWeight: 'semibold',
                color: mode('gray.700', 'gray.300')(props),
                px: { base: 3, md: 4 },
                py: { base: 1.5, md: 2 },
                // Faz 4.3++ · 'all' yerine spesifik propertyler
                transition: 'background-color var(--motion-duration-base) var(--motion-ease-apple), color var(--motion-duration-base) var(--motion-ease-apple), transform var(--motion-duration-base) var(--motion-ease-apple), box-shadow var(--motion-duration-base) var(--motion-ease-apple)',
                _selected: {
                    // GÜNCELLENDİ: mode ile manuel kontrast
                    color: mode(lightPillColor, darkPillColor)(props),
                    bg: mode(`${c}.500`, `${c}.300`)(props),
                    boxShadow: 'md',
                },
                _hover: {
                    bg: !props.isSelected ? mode('gray.100', 'gray.700')(props) : undefined,
                },
                _active: {
                    transform: 'scale(0.97)',
                }
            }
        }
    },
    // Apple tarzı pill tabs - Proje temasına tam entegre, mükemmel responsive
    'apple-pills': (props) => {
        return {
            root: {
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
            },
            tablist: {
                bg: mode('gray.100', 'bgSecondary')(props),
                borderRadius: { base: 'xl', md: 'full' },
                p: { base: '5px', md: '4px' },
                gap: { base: '3px', md: '2px' },
                display: 'inline-flex',
                flexWrap: { base: 'wrap', md: 'nowrap' },
                justifyContent: 'center',
                border: '1px solid',
                borderColor: mode('gray.200', 'borderPrimary')(props),
                maxW: { base: '100%', md: 'none' },
                mx: 'auto',
            },
            tab: {
                borderRadius: { base: 'lg', md: 'full' },
                fontWeight: '500',
                fontSize: { base: 'xs', md: 'sm' },
                color: mode('gray.600', 'textSecondary')(props),
                px: { base: 3, md: 4 },
                py: { base: 2, md: 2 },
                // Faz 4.3++ · 'all' yerine spesifik propertyler (mikro takilmalari onler)
                transition: 'background-color var(--motion-duration-fast) var(--motion-ease-apple), color var(--motion-duration-fast) var(--motion-ease-apple), transform var(--motion-duration-fast) var(--motion-ease-apple), box-shadow var(--motion-duration-fast) var(--motion-ease-apple)',
                whiteSpace: 'nowrap',
                minW: 'auto',
                flex: { base: '1 1 auto', md: '0 0 auto' },
                position: 'relative',
                zIndex: 1,
                _selected: {
                    color: mode('gray.900', 'white')(props),
                    bg: mode('white', 'whiteAlpha.200')(props),
                    boxShadow: mode(
                        '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04)',
                        '0 2px 8px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.05)'
                    )(props),
                    fontWeight: '600',
                },
                _hover: {
                    color: mode('gray.900', 'textPrimary')(props),
                    bg: mode('whiteAlpha.700', 'whiteAlpha.100')(props),
                },
                _active: {
                    transform: 'scale(0.98)',
                },
                _focus: {
                    boxShadow: 'none',
                    outline: 'none',
                },
                _focusVisible: {
                    boxShadow: mode(
                        '0 0 0 2px var(--chakra-colors-accent)',
                        '0 0 0 2px var(--chakra-colors-accent)'
                    )(props),
                }
            }
        }
    },
    // Glassmorphism dock uyumlu tabs
    glass: (props) => ({
        root: {
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
        },
        tablist: {
            bg: 'headerBg',
            borderRadius: { base: 'xl', md: '2xl' },
            p: { base: 2, md: 2 },
            gap: { base: 1.5, md: 2 },
            display: 'inline-flex',
            flexWrap: { base: 'wrap', md: 'nowrap' },
            justifyContent: 'center',
            border: '1px solid',
            borderColor: 'borderPrimary',
            boxShadow: 'cardElevated',
            backdropFilter: 'saturate(180%) blur(26px)',
            WebkitBackdropFilter: 'saturate(180%) blur(26px)',
            maxW: { base: '100%', md: 'none' },
            mx: 'auto',
        },
        tab: {
            borderRadius: { base: 'lg', md: 'full' },
            fontWeight: '600',
            fontSize: { base: 'xs', md: 'sm' },
            color: mode('gray.600', 'textSecondary')(props),
            px: { base: 3, md: 4 },
            py: { base: 2, md: 2.5 },
            transition: 'all var(--motion-duration-fast) var(--motion-ease-apple)',
            whiteSpace: 'nowrap',
            minW: 'auto',
            flex: { base: '1 1 auto', md: '0 0 auto' },
            position: 'relative',
            zIndex: 1,
            _selected: {
                color: mode('gray.900', 'white')(props),
                bg: mode('whiteAlpha.900', 'whiteAlpha.200')(props),
                boxShadow: mode(
                    '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04)',
                    '0 2px 8px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.05)'
                )(props),
            },
            _hover: {
                color: mode('gray.900', 'textPrimary')(props),
                bg: mode('whiteAlpha.700', 'whiteAlpha.100')(props),
            },
            _active: {
                transform: 'scale(0.98)',
            },
            _focus: {
                boxShadow: 'none',
                outline: 'none',
            },
            _focusVisible: {
                boxShadow: mode(
                    '0 0 0 2px var(--chakra-colors-accent)',
                    '0 0 0 2px var(--chakra-colors-accent)'
                )(props),
            }
        }
    })
  },
  sizes: {
    sm: { tab: { fontSize: 'sm', px: 3, py: 1.5, }, },
    md: { tab: { fontSize: 'md', px: 4, py: 2, }, },
    lg: { tab: { fontSize: 'lg', px: 5, py: 2.5, }, },
  },
  defaultProps: {
    variant: 'soft-rounded',
    size: 'md',
    colorScheme: 'brand',
  },
};

export default Tabs;
